import React, { useState, useEffect } from 'react';
import Button from '~/components/atoms/Button'

export default function FindCta({ className, subheadingClassName, subheading, heading, buttonText ,buttonUrl }) {
  const [pageUrl, setPageUrl] = useState("");
  const [urlCityId, setUrlCityId] = useState("");
  useEffect(() => {
    if (typeof window !== "undefined") {
      const savedLang = localStorage.getItem("siteLanguage");
      const lang = savedLang
        ? savedLang.trim().replace(/['"]+/g, "").toLowerCase()
        : "en";

      const cityId = lang === "en" ? "7917" : "1435"; // London vs Paris
      const origin = window.location.origin || "https://cityrelay.com";
      setUrlCityId(`${origin}/findmyhome?cities=${cityId}`);

      setPageUrl(window.location.href);
    }
  }, []);

  // If you want to see the updated value reliably:
  useEffect(() => {
    if (urlCityId) {
    }
  }, [urlCityId]);

  return (
    <div className={`${className}`}>
      {subheading && <h6 className={`text-h6 mb-4 ${subheadingClassName}`}>{subheading}</h6>}
      {heading && <h4 className="text-h2 mb-6">{heading}</h4>}
      <div className="flex flex-col sm:flex-row mb-8">
        <Button url={buttonUrl || urlCityId} title={buttonText || "Find My Home"} className="inline-flex items-center whitespace-nowrap find-my-home" />
      </div>
    </div>
  )
}
